import { Session, OpenVidu, Publisher, PublisherProperties } from "openvidu-browser-v2compatibility";

export class OpenViduProvider extends OpenVidu {
  ov: OpenVidu;
  constructor() {
    super();
    this.ov = new OpenVidu();
  }

  getOpenviduInstance() {
    return this.ov;
  }

  // TODO: https://docs.openvidu.io/en/stable/api/openvidu-browser-v2compatibility/interfaces/OpenViduAdvancedConfiguration.html
  initializeSession(): Session {
    this.ov.setAdvancedConfiguration({
      iceConnectionDisconnectedExceptionTimeout: 4000,
      forceMediaReconnectionAfterNetworkDrop: true,
      noStreamPlayingEventExceptionTimeout: 5000,
    });
    const session = this.ov.initSession();
    this.disablePublishSimulcast(session);
    return session;
  }

  // Grava em camada ÚNICA, na resolução cheia. O SDK v2compat fixa roomOptions={}, então o
  // simulcast nasce ligado (default do livekit-client) e o auto track egress grava a camada
  // baixa (q, ~180x240) em vez da alta. O publishDefaults do livekit é lido POR REFERÊNCIA no
  // publishTrack, e o Room passa o mesmo objeto `options` ao LocalParticipant — então mexer
  // aqui, depois do initSession e antes do publish, desliga o simulcast sem patch no
  // node_modules (sobrevive a `npm update` do SDK). O guard degrada pro comportamento atual
  // se um upgrade futuro mudar o shape de room.options.
  private disablePublishSimulcast(session: Session): void {
    const publishDefaults = (
      session as unknown as {
        room?: { options?: { publishDefaults?: { simulcast?: boolean } } };
      }
    ).room?.options?.publishDefaults;
    if (publishDefaults) {
      publishDefaults.simulcast = false;
    } else {
      console.warn(
        "[OpenViduProvider] room.options.publishDefaults ausente — simulcast não desligado (SDK mudou de shape?)"
      );
    }
  }

  initializePublisher(
    element: HTMLElement | string | undefined,
    options: PublisherProperties,
    callback?: any
  ): Publisher {
    return this.ov.initPublisher(element!, options, callback);
  }
}
